var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecor4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 64,
    viewBox: "0 0 160 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#EDBD48"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 2,
    r: 2,
    fill: "#EDBD48"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 2,
    r: 2,
    fill: "#EDBD48"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 2,
    r: 2,
    fill: "#EDBD48"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 2,
    r: 2,
    fill: "#EDBD48"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 2,
    r: 2,
    fill: "#EDBD48"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 2,
    r: 2,
    fill: "#EDBD48"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 2,
    r: 2,
    fill: "#EDBD48"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 2,
    r: 2,
    fill: "#EDBD48"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 2,
    r: 2,
    fill: "#EDBD48"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 14,
    r: 2,
    fill: "#EDBD48"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 2,
    fill: "#EDBD48"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 14,
    r: 2,
    fill: "#EDBD48"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 14,
    r: 2,
    fill: "#EDBD48"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 14,
    r: 2,
    fill: "#EDBD48"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 14,
    r: 2,
    fill: "#EDBD48"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 14,
    r: 2,
    fill: "#EDBD48"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 14,
    r: 2,
    fill: "#EDBD48"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 14,
    r: 2,
    fill: "#EDBD48"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 14,
    r: 2,
    fill: "#EDBD48"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 14,
    r: 2,
    fill: "#EDBD48"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 14,
    r: 2,
    fill: "#EDBD48"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 26,
    r: 2,
    fill: "#EDBD48"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 26,
    r: 2,
    fill: "#EDBD48"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 2,
    fill: "#EDBD48"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 26,
    r: 2,
    fill: "#EDBD48"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 26,
    r: 2,
    fill: "#EDBD48"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 26,
    r: 2,
    fill: "#EDBD48"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 26,
    r: 2,
    fill: "#EDBD48"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 26,
    r: 2,
    fill: "#EDBD48"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 26,
    r: 2,
    fill: "#EDBD48"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 26,
    r: 2,
    fill: "#EDBD48"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 26,
    r: 2,
    fill: "#EDBD48"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 26,
    r: 2,
    fill: "#EDBD48"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 26,
    r: 2,
    fill: "#EDBD48"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 26,
    r: 2,
    fill: "#EDBD48"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 38,
    r: 2,
    fill: "#EDBD48"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 38,
    r: 2,
    fill: "#EDBD48"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 38,
    r: 2,
    fill: "#EDBD48"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 2,
    fill: "#EDBD48"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 38,
    r: 2,
    fill: "#EDBD48"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 38,
    r: 2,
    fill: "#EDBD48"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 38,
    r: 2,
    fill: "#EDBD48"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 38,
    r: 2,
    fill: "#EDBD48"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 38,
    r: 2,
    fill: "#EDBD48"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 38,
    r: 2,
    fill: "#EDBD48"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 38,
    r: 2,
    fill: "#EDBD48"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 38,
    r: 2,
    fill: "#EDBD48"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 38,
    r: 2,
    fill: "#EDBD48"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 38,
    r: 2,
    fill: "#EDBD48"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 50,
    r: 2,
    fill: "#EDBD48"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 50,
    r: 2,
    fill: "#EDBD48"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 50,
    r: 2,
    fill: "#EDBD48"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 50,
    r: 2,
    fill: "#EDBD48"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 2,
    fill: "#EDBD48"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 50,
    r: 2,
    fill: "#EDBD48"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 50,
    r: 2,
    fill: "#EDBD48"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 50,
    r: 2,
    fill: "#EDBD48"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 50,
    r: 2,
    fill: "#EDBD48"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 50,
    r: 2,
    fill: "#EDBD48"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 50,
    r: 2,
    fill: "#EDBD48"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 50,
    r: 2,
    fill: "#EDBD48"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 50,
    r: 2,
    fill: "#EDBD48"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 50,
    r: 2,
    fill: "#EDBD48"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 62,
    r: 2,
    fill: "#EDBD48"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 62,
    r: 2,
    fill: "#EDBD48"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 62,
    r: 2,
    fill: "#EDBD48"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 62,
    r: 2,
    fill: "#EDBD48"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 62,
    r: 2,
    fill: "#EDBD48"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 2,
    fill: "#EDBD48"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 62,
    r: 2,
    fill: "#EDBD48"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 62,
    r: 2,
    fill: "#EDBD48"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 62,
    r: 2,
    fill: "#EDBD48"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 62,
    r: 2,
    fill: "#EDBD48"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 62,
    r: 2,
    fill: "#EDBD48"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 62,
    r: 2,
    fill: "#EDBD48"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 62,
    r: 2,
    fill: "#EDBD48"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 62,
    r: 2,
    fill: "#EDBD48"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecor4);
export default __webpack_public_path__ + "static/media/decor-4.a49a6102.svg";
export { ForwardRef as ReactComponent };